module.exports = __webpack_public_path__ + "static/img/right-resting-hand.fac776bd.png";